import React, {PureComponent} from 'react';
import {  Redirect } from 'react-router-dom';
import {AppSettings,Storage} from '../../configs'; 

class SecureGateRoute extends PureComponent{    
    render(){

        const {location}=this.props
        let user=Storage.getUser()
        console.log("check securegate ==>>",user && user.token && user.userName)
        return(
            user && user.token && user.userName
            ? null
            : <Redirect to={{ pathname: AppSettings.loginUrl, state: { from: location } }} />
        )
    }
}

export default SecureGateRoute;